/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Inventory_Status_OkInputs */

const vi_report_inventory_status_ok = /** @type {(inputs: Report_Inventory_Status_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bình thường`)
};

/**

* @param {Report_Inventory_Status_OkInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_inventory_status_ok = /** @type {((inputs?: Report_Inventory_Status_OkInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Inventory_Status_OkInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_inventory_status_ok(inputs)
});